/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { any } from 'prop-types';
import * as drawerStyles from './drawers.module.scss';

export const Footer = ({ children }) => (
  <div className={`${drawerStyles.footer}`}>
    {children}
  </div>
);

Footer.propTypes = {
  children: any.isRequired
};